export default __webpack_public_path__ + "static/top-eb2854169b670d432e8627e14885b6e5.jpg";